import React, {FC, SVGProps} from 'react';
import {Icon, Icons, Tooltip, TwoLinesCell} from '@silverfort/sf-components';

interface DisplayNameColumnProps {
    topText: string;
    bottomText: string;
    onTopTextClick?: () => void;
    onActionClick: () => void;
    actionIcon?: FC<SVGProps<SVGSVGElement>>;
    actionTooltip?: string;
}

const DisplayNameColumn: FC<DisplayNameColumnProps> = ({
                                                     topText,
                                                     bottomText,
                                                     onTopTextClick,
                                                     onActionClick,
                                                     actionIcon = Icons.Investigate,
                                                     actionTooltip = "Investigate"
                                                 }) => {
    return (
        <TwoLinesCell
            topElement={
                <Tooltip title={topText} onlyOnOverflow onClick={onTopTextClick}>
                    <span className="truncate">{topText}</span>
                </Tooltip>
            }
            bottomText={bottomText}
            rightIcon={() => (
                <div>
                    <Tooltip title={actionTooltip} placement="top-end">
                        <div
                            className="invisible group-hover:visible"
                            onClick={onActionClick}
                        >
                            <Icon
                                size={20}
                                icon={actionIcon as FC<SVGProps<SVGSVGElement>>}
                                className="text-sf-gray-400"
                            />
                        </div>
                    </Tooltip>
                </div>
            )}
        />
    );
};

export default DisplayNameColumn;
